import {config} from "./config";
import {request} from "./request";

function createOrUpdateUserProduct(data, cb, fail_cb) {
    request.post.call(this, config.apiList.userProducts, data, null, cb, fail_cb)
}

function getUserProducts(data, cb, fail_cb) {
    request.get.call(this, config.apiList.userProducts, data, cb, fail_cb)
}

function deleteUserProduct(data, cb, fail_cb) {
    request.deleteRequest.call(this, config.apiList.userProducts + '/' + data.id, data, cb, fail_cb)
}


var userProductApi = {
    createOrUpdateUserProduct: createOrUpdateUserProduct,
    getUserProducts: getUserProducts,
    deleteUserProduct: deleteUserProduct,
}

export {userProductApi}